// @flow
import ko from 'rgs-knockout';
import BaseViewModel from './base';

export default class DmsViewModel
	extends BaseViewModel
	implements IViewModel {
	constructor (options) {
		super(options);
		
		this._options = options;

		this.isSmsCheckboxesGridVisible = ko.pureComputed(() => {
			return this._options.checkboxesOptions
			? this._options.checkboxesOptions.isSmsCheckboxesGridVisible
			: true;
		});

		this.isTermsAgreementChecked = this._options.checkboxesOptions
            ? this._options.checkboxesOptions.isTermsAgreementChecked
            : true;
		this.needError = ko.pureComputed(() => {
			return this._options.checkboxesOptions.isTermsAgreementChecked
            ? !(this._options.checkboxesOptions.isTermsAgreementChecked()) : true;
		});
		this.isAdvsAgreementChecked = this._options.checkboxesOptions
            ? this._options.checkboxesOptions.isAdvsAgreementChecked
            : true;
	}

	onCheckTerms = () => this._options.checkboxesOptions.onCheckTermsAgreement;

	onCheckAdvs = () => this._options.checkboxesOptions.onCheckAdvsAgreement;

	onSendCodeClick = () => this._options.checkboxesOptions.onSendCodeClick(this);

	onTermsLinkClick = () => this._options.checkboxesOptions.onTermsLinkClick(this);

	onAdvsLinkClick = () => this._options.checkboxesOptions.onAdvsLinkClick(this);
}